import Skeleton from '@/components/ui/custom/Skeleton';

export default function CellSkeleton() {
  return <Skeleton className="h-4 w-full rounded" />;
}
